import { API, getAsyncThunk } from 'app/api';

export const getProfileThunk = getAsyncThunk(
  'PROFILE:GET_PROFILE',
  API.client.clientProfile.getProfile,
);
